import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

interface ProfileAvatarProps {
  url: string | null;
  onUploadClick: () => void;
  uploading: boolean;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ url, onUploadClick, uploading }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <Avatar className="h-24 w-24">
        <AvatarImage src={url || undefined} />
        <AvatarFallback>?</AvatarFallback>
      </Avatar>
      <div>
        <Button
          variant="outline"
          disabled={uploading}
          onClick={onUploadClick}
        >
          {uploading ? 'Uploading...' : 'Upload Avatar'}
        </Button>
      </div>
    </div>
  );
};

export default ProfileAvatar;